var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScansIconMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scans-icon",
    transform: "translate(8.4 8.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1276",
    "data-name": "Rectangle 1276",
    width: 56,
    height: 56,
    rx: 8,
    transform: "translate(-8.4 -8.4)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4367",
    "data-name": "Path 4367",
    d: "M13.433,5.267A3.267,3.267,0,0,1,16.7,8.533V19.684a12.033,12.033,0,0,0-5.448-2.145l-.537,3.222A7.723,7.723,0,0,1,15.3,22.81a6.314,6.314,0,0,1,1.4,4.507,4.083,4.083,0,0,1-8.167,0v-.573a14.386,14.386,0,0,0,2.181.551l.537-3.222A13.983,13.983,0,0,1,7.6,22.841,4.077,4.077,0,0,1,5.267,19.15a5.378,5.378,0,0,1,.913-3.225A4.64,4.64,0,0,1,8.929,14.2l1.237-.309V8.533A3.267,3.267,0,0,1,13.433,5.267Zm4.9-1.055A6.533,6.533,0,0,0,6.9,8.533v2.9A7.578,7.578,0,0,0,3.537,14,8.623,8.623,0,0,0,2,19.15a7.335,7.335,0,0,0,3.267,6.112v2.054a7.35,7.35,0,0,0,13.067,4.62A7.35,7.35,0,0,0,31.4,27.317V25.262a7.334,7.334,0,0,0,3.267-6.112A8.623,8.623,0,0,0,33.129,14a7.577,7.577,0,0,0-3.363-2.573v-2.9A6.533,6.533,0,0,0,18.333,4.212Zm9.8,22.532v.573a4.083,4.083,0,0,1-8.167,0,6.314,6.314,0,0,1,1.4-4.507,7.723,7.723,0,0,1,4.581-2.049l-.537-3.222a12.033,12.033,0,0,0-5.448,2.145V8.533a3.267,3.267,0,1,1,6.533,0v5.359l1.237.309a4.64,4.64,0,0,1,2.75,1.724A5.379,5.379,0,0,1,31.4,19.15a4.077,4.077,0,0,1-2.334,3.691,13.982,13.982,0,0,1-3.651,1.231l.537,3.222A14.386,14.386,0,0,0,28.133,26.744Z",
    transform: "translate(1.267 1.267)",
    fill: "#fff",
    stroke: "#09c",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScansIconMenu);
export default __webpack_public_path__ + "static/media/scans-icon-menu.1e60eb1f1f8fb46750f37fd6df722f4d.svg";
export { ForwardRef as ReactComponent };